SupportMarketRateImagePresenterPresentation = require('../presenters/market_rate_image_presenter')
SupportPresenterFactoryPresentation = require('../presenters/presenter_factory')
Mustache = require('../../../../core/frontend/vendor_modules/mustache-0.7.2')
SupportUtilsHelper = require('../helpers/utils')

class SupportCurrentOrderModel

  constructor: ->
    @currentOrder = Groupon.Support.currentOrder
    @groupons = @currentOrder.groupons
    @voucher = _.first (@groupons || [])

  getDealFinePrint: ->
    @currentOrder.finePrintText || @currentOrder.deal?.finePrint || ""

  getV1ImageUrl: ->
    @currentOrder.deal?.sidebarImageUrl || @currentOrder.deal?.mediumImageUrl || @currentOrder.deal?.smallImageUrl

  toDealHash: ->
    dealHash = switch @currentOrder.DEAL_TYPE
      when 'GETAWAYS_TONIGHT', 'GETAWAYS_MARKET_RATE' then @getawaysMarketRateDealHash()
      when 'GETAWAYS_BOOKING'
        if isIntl() then @getawaysBookingDealHash() else @v1DealHash()
      else @v1DealHash()
    dealHash

  v1DealHash: ->
    dealHash =
      dealId: @currentOrder.deal?.id
      merchant: @currentOrder.merchant?.name
      title: @currentOrder.deal?.title
      v1Image: @getV1ImageUrl()
      finePrint: @getDealFinePrint()

  getawaysBookingDealHash: ->
    reservationSource = SupportUtilsHelper.getReservationSource(@currentOrder)
    dealHash =
      merchant: reservationSource?.hotelName || @currentOrder.merchant?.name
      title: reservationSource?.roomNameHtml || @currentOrder.deal?.title
      v1Image: @getV1ImageUrl()
      dealId: @currentOrder.deal?.id
      finePrint: @getDealFinePrint()

  getawaysMarketRateDealHash: ->
    reservationSource = SupportUtilsHelper.getReservationSource(@currentOrder)
    dealHash =
      merchant: reservationSource?.hotelName
      title: reservationSource?.roomNameHtml
      finePrint: @getDealFinePrint()

    if @currentOrder.DEAL_TYPE is 'GETAWAYS_MARKET_RATE'
      reservationSource = SupportUtilsHelper.getReservationSource(@currentOrder)
      dealHash.imageUrl = @currentOrder.imageUrl || (new SupportMarketRateImagePresenterPresentation).present reservationSource?.images
    else
      dealHash.imageUrl = @currentOrder.imageUrl
    dealHash

  getOrderQuantity: ()->
    quantity = @currentOrder.quantity
    unless quantity?
      quantity = SupportUtilsHelper.findGrouponQuantity(@groupons)
    quantity

  buildOrderSummaryParams: ->

    statusNotesHash = @getDealStatusAndNotes()
    orderSummaryParams =
      qty : @getOrderQuantity()
      shouldShowDeliveryMsg : @currentOrder.shouldShowDeliveryMsg
      purchasedAt     : @getpurchasedAt()
      maxDeliveryDays : window.maxDeliveryDays[window.country.name]
      status : Mustache.to_html(statusNotesHash.status, @statusParams(statusNotesHash.status))
      notes  : if statusNotesHash.notes? and statusNotesHash.notes.length != 0 then Mustache.to_html(statusNotesHash.notes, @notesParams(statusNotesHash.notes))
      deliveryRange: @getEstimatedDeliveryRange()
      giftInfo: @getGiftParams()
    _.extend orderSummaryParams, window.getOrderInfoForBH(@currentOrder)

    switch @currentOrder.DEAL_TYPE
      when 'GETAWAYS_TONIGHT', 'GETAWAYS_MARKET_RATE', 'GETAWAYS_BOOKING' then _.extend orderSummaryParams, @getReseravationParams()
    orderSummaryParams

  getpurchasedAt: () ->
    @currentOrder.purchasedAtshortDatetimeStr

  getEstimatedDeliveryRange: ->
    if @canShowEstimatedDelivery()
      if @currentOrder.shipmentDetails
        shipmentDetails = @currentOrder.shipmentDetails
        if shipmentDetails.deliveredDate || shipmentDetails.outFordeliveryDate || shipmentDetails.shippedDate
          return null
        else
          deliveryRange = shipmentDetails.shippingSoonRange ||  shipmentDetails.shippingSoonRangePlusTwoDays || shipmentDetails.estimatedDeliveryDescription
          if deliveryRange
            return deliveryRange
      return @currentOrder.deal?.deliveryRange
    else
      return null

  canShowEstimatedDelivery: () ->
    @currentOrder.STATE not in ['FAILED', 'REFUNDED']

  getReseravationParams : ->
    reservationInformation = {}
    reservationSource = SupportUtilsHelper.getReservationSource(@currentOrder)
    if reservationSource?.formattedCheckInDate
      reservationInformation.checkInDate = reservationSource?.formattedCheckInDate
    if reservationSource?.formattedCheckOutDate
      reservationInformation.checkOutDate =  reservationSource?.formattedCheckOutDate
    reservationInformation

  notesParams: (notes)->
    notesParams = {}
    if notes?.match("editable_deadline")
      notesParams.editable_deadline = @currentOrder.editableUntillongDateTimeStr
    if notes?.match("expired_date")
      notesParams.expiration_date = @voucher.expiresAtFormattedStr
    if notes?.match("merchant_name")
      notesParams.merchant_name = @currentOrder.merchant.name
    if notes?.match("isEditableUntil")
      notesParams.isEditableUntil = @currentOrder.isEditableUntil
    if notes?.match("number_of_business_days_ago")
      notesParams.number_of_business_days_ago = @currentOrder.businessDaysAfterPurchase
    @setShippingNotesParams(notes, notesParams)

  setShippingNotesParams: (notes, notesParams)->
    shipmentDetails = @currentOrder.shipmentDetails
    if shipmentDetails
      if notes?.match("shipped_date")
        notesParams.shipped_date = shipmentDetails.shippedDate
      if notes?.match("out_for_delivery_date")
        notesParams.out_for_delivery_date = shipmentDetails.outFordeliveryDate
      if notes?.match("delivered_date")
        notesParams.delivered_date = shipmentDetails.deliveredDate
      if notes?.match("tracking_number")
        notesParams.tracking_number = shipmentDetails.trackingNumber
      if notes?.match("carrier_name")
        notesParams.carrier_name = shipmentDetails.carrierName?.toUpperCase()
      @setShippingSoonMsg(notes, notesParams)
    notesParams

  setShippingSoonMsg: (notes, notesParams)->
    notesParams.shipping_soon_msg = @currentOrder.deal?.deliveryRange || ""
    notesParams.shipping_soon_msg_plus_two_business_days = @currentOrder.deal?.deliveryRange | ""
    shipmentDetails = @currentOrder.shipmentDetails
    if shipmentDetails
      if notes?.match("shipping_soon_msg")
        if shipmentDetails.shippingSoonRange?
          notesParams.shipping_soon_msg = "Your order has been prepared for shipment and will be picked up by the carrier by #{shipmentDetails.shippingSoonRange}."
        else if shipmentDetails.estimatedDeliveryDescription?
          notesParams.shipping_soon_msg = shipmentDetails.estimatedDeliveryDescription
      if notes?.match("shipping_soon_msg_plus_two_business_days")
        if shipmentDetails.shippingSoonRangePlusTwoDays?
          notesParams.shipping_soon_msg_plus_two_business_days = "Your order has been prepared for shipment and will be picked up by the carrier by #{shipmentDetails.shippingSoonRangePlusTwoDays}."
        else if shipmentDetails.estimatedDeliveryDescription?
          notesParams.shipping_soon_msg_plus_two_business_days = shipmentDetails.estimatedDeliveryDescription

  statusParams: (status)->
    statusParams = {}
    if status?.match("redeemed_date")
      statusParams.redeemed_date = @voucher.merchantRedeemedAtshortDatetimeStr || @voucher.customerRedeemedAtshortDatetimeStr
    if status?.match("expiration_date")
      statusParams.expiration_date = @voucher.expiresAtFormattedStr
    if status?.match("editable_deadline")
      statusParams.editable_deadline = @currentOrder.editableUntilshortDateTimeStr
    statusParams

  getDealStatusAndNotes: () ->
    displayStatus = Groupon.Support.ContentModel.displayStatus
    displayNotes = Groupon.Support.ContentModel.displayNotes
    if checkIfIsUSByCountry(country.name)
      presenter = SupportPresenterFactoryPresentation::makePresenter(@currentOrder)
      status: presenter.getStatus()
      notes: presenter.getNotes()
    else if (displayStatus || displayNotes)
      status: displayStatus
      notes: displayNotes
    else
      status: Groupon.Support.currentOrder.STATE

  getGiftParams: (order, I18n) ->
    if @currentOrder.isGift && @currentOrder.giftInfo
      hash =
        isSentGift: @currentOrder.giftInfo.isSentGift
        isReceivedGift: @currentOrder.giftInfo.isReceivedGift
        giftRecipientName : @currentOrder.giftInfo.giftRecipientName
        giftFromName: @currentOrder.giftInfo.giftFromName
        giftRecipientEmail: @currentOrder.giftInfo.giftRecipientEmail
        isGiftClaimed: @currentOrder.isGiftClaimed
        printedAt: @currentOrder.giftInfo.printedAtshortDatetimeStr
      switch @currentOrder.giftInfo.giftDeliveryMethod
        when 'email'
          hash.isEGift = true
        else
          hash.isPrintedGift = true
      hash

module.exports = SupportCurrentOrderModel
